import React, { FC } from 'react';
import styles from './styles.module.css';
import { Button } from '@clearcover/atlas';
import { reportEvent } from 'Shared/analytics';

export const ChallengesFailure: FC<{
  rewardsCenterRefresh: () => void;
}> = ({ rewardsCenterRefresh }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <h2>We experienced an error</h2>
        <div className={styles.text}>
          Your points are secure, but we ran into an issue while connecting to
          our reward system. Please refresh to try again. If the issue persists,
          please reach out to our support team for further assistance.
        </div>
        <Button
          type="button"
          variant="secondary"
          data-testid="rewards-center-challenges-error-retry"
          onClick={() => {
            reportEvent('rewards-challenges-error-try-again');
            rewardsCenterRefresh();
          }}
        >
          Try Again
        </Button>
      </div>
    </div>
  );
};
